import { ChangeDetectionStrategy, Component, inject, ViewChild } from '@angular/core';
import { BaseModalComponent } from '../../../../core/layout/components/abstracts/base-modal.component';
import { ModalComponent } from '../../../../shared/components/modal/modal.component';
import { TranslatePipe } from '../../../../shared/pipes/trans.pipe';
import { OnlineOrderStatuses } from '../../core/enums/OnlineOrderStatuses';
import { OnlineOrdersScreenService } from '../../core/services/OnlineOrdersScreenService';
import { OnlineOrdersStore } from '../../core/stores/OnlineOrdersStore';
import { OnlineOrdersSearchComponent } from '../../views/online-orders-search/online-orders-search.component';
import {
  OnlineOrderDetailsModalComponent
} from '../online-order-details-modal/online-order-details-modal.component';

@Component({
  selector: 'app-online-orders-modal',
  standalone: true,
  imports: [
    ModalComponent,
    TranslatePipe,
    OnlineOrdersSearchComponent,
    OnlineOrderDetailsModalComponent,
  ],
  providers: [OnlineOrdersStore, OnlineOrdersScreenService],
  templateUrl: './online-orders-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OnlineOrdersModalComponent extends BaseModalComponent {

  @ViewChild('onlineOrderDetailsModalComponent') onlineOrderDetailsModalComponent: OnlineOrderDetailsModalComponent;

  private readonly _onlineOrdersScreenService = inject(OnlineOrdersScreenService);

  public readonly orders = this._onlineOrdersScreenService.orders;
  public readonly status = this._onlineOrdersScreenService.status;
  public readonly pagination = this._onlineOrdersScreenService.pagination;
  public readonly isLoading = this._onlineOrdersScreenService.isLoading;

  public override open(val?: null): void {
    this._onlineOrdersScreenService.resetForOpen();
    super.open(val);
    this._onlineOrdersScreenService.loadOrders();
  }

  public setStatus(status: OnlineOrderStatuses): void {
    this._onlineOrdersScreenService.setStatus(status);
  }

  public setSearch(search: string): void {
    this._onlineOrdersScreenService.setSearch(search);
  }

  public setPage(page: number): void {
    this._onlineOrdersScreenService.setPage(page);
  }

  public loadOrders(): void {
    this._onlineOrdersScreenService.loadOrders();
  }
}
